<template>
  <div>
    <!-- <v-layout justify-center wrap>
      <v-flex xs12>
        <v-navigation-drawer
          v-model="sideNav3"
          fixed
          temporary
          color="#202020"
          class="hidden-lg-and-up"
        >
          <v-layout wrap justify-center>
            <v-flex
              xs12
              v-for="(item, i) in categories"
              :key="i"
              text-center
              pa-2
              pl-4
              text-uppercase
              align-self-center
            >
              <v-layout wrap justify-center>
                <router-link :to="item.route" style="text-decoration: none">
                  <v-flex xs12>
                    <span
                      style="
                        font-family: futurabook;
                        font-size: 15px;
                        color: #ffffff;
                        letter-spacing: 3px;
                        cursor: pointer;
                      "
                      >{{ item.name }}</span
                    >
                  </v-flex>
                </router-link>
                <v-flex xs12 pt-2>
                  <div style="border-bottom: 1px solid #ffffff25"></div>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-navigation-drawer>
      </v-flex>
    </v-layout> -->
    <!-- elevate-on-scroll
      hide-on-scroll -->
    <v-app-bar app height="160px" class="hidden-xs-only" elevation="3">
      <v-layout wrap justify-start hidden-xs-only fill-height>
        <v-flex xs12 align-self-start>
          <Notification />
        </v-flex>
        <v-flex xs12 sm12 md12>
          <v-layout wrap justify-center>
            <!-- <v-flex xs4 md4>
               <v-img
                width="100px"
                height="150px"
                contain
                src="./../../assets/nellilogo.png"
              ></v-img>
            </v-flex> -->
            <v-flex xs12 sm10 text-center>
              <v-layout wrap justify-space-between>
                <!-- <v-flex v-for="(item, i) in categories" :key="i">
                  <router-link :to="item.route" style="text-decoration: none">
                    <span
                      style="
                         font-family: sofiaProSemiBold;
                        font-size: 18px;
                        cursor: pointer;
                        color: #101010;
                      "
                    >
                      {{ item.name }}
                    </span>
                  </router-link>
                </v-flex> -->

                <v-flex align-self-center>
                  <router-link to="/about" style="text-decoration: none">
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-icon
                          size="30"
                          :color="
                            $route.path == '/about' ? '#f0ad05' : '#036917'
                          "
                          >mdi-information</v-icon
                        >
                      </v-flex>
                      <v-flex>
                        <span
                          style="
                            font-family: sofiaProSemiBold;
                            font-size: 18px;
                            cursor: pointer;
                          "
                          :style="
                            $route.path == '/about'
                              ? 'color:#f0ad05'
                              : 'color:#036917'
                          "
                        >
                          About
                        </span></v-flex
                      >
                    </v-layout>
                  </router-link>
                </v-flex>
                <v-flex align-self-center>
                  <router-link to="/ecoTourism" style="text-decoration: none">
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-icon
                          size="35"
                          :color="
                            $route.path == '/ecoTourism' ? '#f0ad05' : '#036917'
                          "
                          >mdi-pine-tree</v-icon
                        >
                      </v-flex>
                      <v-flex>
                        <span
                          style="
                            font-family: sofiaProSemiBold;
                            font-size: 18px;
                            cursor: pointer;
                            color: #036917;
                          "
                          :style="
                            $route.path == '/ecoTourism'
                              ? 'color:#f0ad05'
                              : 'color:#036917'
                          "
                        >
                          Eco Tourism
                        </span>
                      </v-flex>
                    </v-layout>
                  </router-link>
                </v-flex>
                <v-flex xs1>
                  <router-link to="/" style="text-decoration: none">
                    <v-img
                      width="100px"
                      height="110px"
                      contain
                      src="./../../assets/nellilogo.png"
                    ></v-img>
                  </router-link>
                </v-flex>
                <v-flex align-self-center>
                  <router-link to="/media" style="text-decoration: none">
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-icon
                          size="30"
                          :color="
                            $route.path == '/media' ? '#f0ad05' : '#036917'
                          "
                          >mdi-image-multiple</v-icon
                        >
                      </v-flex>
                      <v-flex>
                        <span
                          style="
                            font-family: sofiaProSemiBold;
                            font-size: 18px;
                            cursor: pointer;
                            color: #036917;
                          "
                          :style="
                            $route.path == '/media'
                              ? 'color:#f0ad05'
                              : 'color:#036917'
                          "
                        >
                          Media
                        </span>
                      </v-flex>
                    </v-layout>
                  </router-link>
                </v-flex>
                <v-flex align-self-center>
                  <router-link to="/contact" style="text-decoration: none">
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-icon
                          size="30"
                          :color="
                            $route.path == '/contact' ? '#f0ad05' : '#036917'
                          "
                          >mdi-email</v-icon
                        >
                      </v-flex>
                      <v-flex>
                        <span
                          style="
                            font-family: sofiaProSemiBold;
                            font-size: 18px;
                            cursor: pointer;
                            color: #036917;
                          "
                          :style="
                            $route.path == '/contact'
                              ? 'color:#f0ad05'
                              : 'color:#036917'
                          "
                        >
                          Contact Us
                        </span>
                      </v-flex>
                    </v-layout>
                  </router-link>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-app-bar>
  </div>
</template>
<script>
// import axios from "axios";
// import store from "../../store";
// import AccountMenu from "./accountMenu";
import Notification from "./notification";
export default {
  components: {
    //     AccountMenu,
    Notification,
  },
  data() {
    return {
      hover: false,
      appLoading: false,
      ServerError: false,
      sideNav: false,
      sideNav2: false,
      sideNav3: false,
      user: [],
      categories: [
        // {
        //   name: "Home",
        //   route: "/",
        //   type: "link",
        // },
        {
          name: "About",
          route: "/about",
          type: "link",
        },
        {
          name: "Eco Tourism",
          route: "/noticeboard2",
          type: "link",
        },
        {
          name: "Media",
          route: "/topperVideo",
          type: "link",
        },
        {
          name: "Contact Us",
          route: "/profile",
          type: "link",
        },
      ],
      stylCategories: [],
      userName: null,
      profilePic: null,
      cartItems: 0,
      disabledNav: true,
      searchKey: null,
    };
  },
  watch: {
    sideNav() {
      this.$emit("stepper", {
        sideNav: this.sideNav,
      });
    },
  },
};
</script>

<style>
input::-webkit-input-placeholder {
  color: #c5c5c5 !important;
  font-size: 14px !important;
  font-family: poppinsregular !important;
}
input::-moz-placeholder {
  color: #c5c5c5 !important;
  font-size: 14px !important;
  font-family: poppinsregular !important;
}
.searchBox .v-input__control {
  min-height: 10px !important;
}
.searchBox .v-input__control .v-input__slot {
  padding: 0px !important;
}
.v-application--is-ltr
  .v-toolbar__content
  > .v-btn.v-btn--icon:first-child
  + .v-toolbar__title,
.v-application--is-ltr
  .v-toolbar__extension
  > .v-btn.v-btn--icon:first-child
  + .v-toolbar__title {
  padding-left: 0px !important;
}

.v-toolbar__content {
  padding: 0px !important;
}
</style>
